import type { TerminalWeeklyPlanTotal } from "../../../shared/production/terminal-work-orders";

export function OperatorWeeklyPlanTotal({ plan, compact = false }: { plan: TerminalWeeklyPlanTotal | null | undefined; compact?: boolean }) {
  if (!plan) return null;
  const quantity = !plan.unit ? "Birim doğrulanamadı" : plan.quantity === null ? "Miktar doğrulanamadı" : `${new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 6 }).format(plan.quantity)} ${plan.unit}`;
  return <span className="operator-weekly-plan-total">
    <span>{compact ? quantity : `Bu hafta planlanan toplam: ${quantity}`}</span>
    <small>{plan.country ?? "Ülke belirtilmemiş"}</small>
    {!compact ? <small>Plan haftası: {new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "long", year: "numeric", timeZone: "Europe/Istanbul" }).format(new Date(`${plan.revision.weekStart}T12:00:00+03:00`))}</small> : null}
  </span>;
}
